export async function assertResponse(response: Response) {
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
}
export async function getJson<T>(response: Response): Promise<T> {
  await assertResponse(response);
  if (response.status === 204) {
    return null as T;
  }
  const text = await response.text();
  return (text === '' ? null : JSON.parse(text)) as T;
}
